import React from 'react';
import './LocalSupport.css';

// Placeholder images
import workerImg from '../assets/worker.jpg';
import argentinaFlagImg from '../assets/argentina-flag.jpg';

function LocalSupport() {
  return (
    <section className="local-support-section">
      <div className="container">
        <h2>FABRICACIÓN Y RESPALDO LOCAL</h2>
        <p>
          Diseñamos y fabricamos nuestros equipos en <strong>Argentina</strong>; con
          repuestos disponibles y <strong>soporte técnico directo</strong>.
        </p>
        <div className="image-gallery">
          <img src={workerImg} alt="Worker in factory" className="support-image" />
          <img src={argentinaFlagImg} alt="Argentinian Flag" className="support-image" />
        </div>
      </div>
    </section>
  );
}

export default LocalSupport;
